import Vue from "vue";
import Message from "./message.vue";

// useage:
// this.$message.success(String)、this.$message.info(String)、this.$message.error(String)

let MessageConstructor = Vue.extend(Message);

let instance;
let instances = [];
let seed = 1;

const CMessage = function(options) {
  if (Vue.prototype.$isServer) return;
  options = options || {};
  if (typeof options === "string") {
    options = {
      message: options
    };
  }
  let id = "message_" + seed++;

  instance = new MessageConstructor({
    data: options
  });
  instance.id = id;

  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;
  instances.push(instance);
  return instance.vm;
};

["success", "info", "error"].forEach(type => {
  CMessage[type] = options => {
    if (typeof options === "string") {
      options = {
        message: options
      };
    }
    options.type = type;
    return CMessage(options);
  };
});

CMessage.close = function(id) {
  for (let i = 0, len = instances.length; i < len; i++) {
    if (id === instances[i].id) {
      instances.splice(i, 1);
      break;
    }
  }
};

CMessage.closeAll = function() {
  for (let i = instances.length - 1; i >= 0; i--) {
    instances[i].close();
  }
};

export default CMessage;
